import { render, staticRenderFns } from "./stat.vue?vue&type=template&id=417cb37f&scoped=true&"
import script from "./stat.vue?vue&type=script&lang=ts&"
export * from "./stat.vue?vue&type=script&lang=ts&"
import style0 from "./stat.vue?vue&type=style&index=0&id=417cb37f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417cb37f",
  null
  
)

export default component.exports